/* tslint:disable */
import {
  CompanyAccount,
  PropertyType,
  UnitFeature,
  Lease,
  TenantLease
} from '../index';

declare var Object: any;
export interface PropertyUnitsInterface {
  "unit_number": string;
  "unit_size"?: string;
  "unit_address"?: string;
  "market_rent"?: number;
  "bed_rooms"?: string;
  "bath_rooms"?: string;
  "description"?: string;
  "property_id": number;
  "occupied"?: boolean;
  "status"?: string;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  "property_type_id"?: number;
  property?: CompanyAccount;
  propertyTypes?: PropertyType;
  unitFeatures?: UnitFeature[];
  leases?: Lease[];
  tenantLease?: TenantLease[];
}

export class PropertyUnits implements PropertyUnitsInterface {
  "unit_number": string;
  "unit_size": string;
  "unit_address": string;
  "market_rent": number;
  "bed_rooms": string;
  "bath_rooms": string;
  "description": string;
  "property_id": number;
  "occupied": boolean;
  "status": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  "property_type_id": number;
  property: CompanyAccount;
  propertyTypes: PropertyType;
  unitFeatures: UnitFeature[];
  leases: Lease[];
  tenantLease: TenantLease[];
  constructor(data?: PropertyUnitsInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PropertyUnits`.
   */
  public static getModelName() {
    return "PropertyUnits";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PropertyUnits for dynamic purposes.
  **/
  public static factory(data: PropertyUnitsInterface): PropertyUnits{
    return new PropertyUnits(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PropertyUnits',
      plural: 'PropertyUnits',
      path: 'PropertyUnits',
      idName: 'id',
      properties: {
        "unit_number": {
          name: 'unit_number',
          type: 'string'
        },
        "unit_size": {
          name: 'unit_size',
          type: 'string'
        },
        "unit_address": {
          name: 'unit_address',
          type: 'string'
        },
        "market_rent": {
          name: 'market_rent',
          type: 'number',
          default: 0
        },
        "bed_rooms": {
          name: 'bed_rooms',
          type: 'string'
        },
        "bath_rooms": {
          name: 'bath_rooms',
          type: 'string'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "property_id": {
          name: 'property_id',
          type: 'number'
        },
        "occupied": {
          name: 'occupied',
          type: 'boolean',
          default: false
        },
        "status": {
          name: 'status',
          type: 'string',
          default: 'ACTIVE'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
        "property_type_id": {
          name: 'property_type_id',
          type: 'number'
        },
      },
      relations: {
        property: {
          name: 'property',
          type: 'CompanyAccount',
          model: 'CompanyAccount',
          relationType: 'belongsTo',
                  keyFrom: 'property_id',
          keyTo: 'id'
        },
        propertyTypes: {
          name: 'propertyTypes',
          type: 'PropertyType',
          model: 'PropertyType',
          relationType: 'belongsTo',
                  keyFrom: 'property_type_id',
          keyTo: 'id'
        },
        unitFeatures: {
          name: 'unitFeatures',
          type: 'UnitFeature[]',
          model: 'UnitFeature',
          relationType: 'hasMany',
          modelThrough: 'PropertyUnitFeature',
          keyThrough: 'unit_feature_id',
          keyFrom: 'id',
          keyTo: 'property_unit_id'
        },
        leases: {
          name: 'leases',
          type: 'Lease[]',
          model: 'Lease',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'property_unit_id'
        },
        tenantLease: {
          name: 'tenantLease',
          type: 'TenantLease[]',
          model: 'TenantLease',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'property_unit_id'
        },
      }
    }
  }
}
